import { useAuth } from '@on3/ui-lib/contexts/AuthProvider';
import clsx from 'clsx';

import styles from './MobileBanner.module.scss';

interface IAdProps {
  id: string;
}

export const MobileBanner = ({ id }: IAdProps) => {
  const { user } = useAuth();

  if (user?.st?.includes('premium')) {
    return null;
  }

  return <div className={clsx(styles.ad, 'bannerAd')} data-ui="ad" id={id} />;
};
